import { toast } from 'react-toastify';

export const globalErrorHandler = (err) => {
  console.log(err);
  toast.error(err?.response?.data?.message);
};
